import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a UTC timestamp to local time
 * Backend stores timestamps in UTC but MongoDB may strip timezone info
 * This ensures the timestamp is correctly interpreted as UTC before converting to local
 */
export function formatUTCTimestamp(timestamp, options = {}) {
  if (!timestamp) return '';
  
  // Append 'Z' to indicate UTC if not already present
  let utcTimestamp = timestamp;
  if (typeof timestamp === 'string' && !timestamp.endsWith('Z') && !timestamp.includes('+')) {
    utcTimestamp = timestamp + 'Z';
  }
  
  const date = new Date(utcTimestamp);
  
  // Default options for display
  const defaultOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  
  return date.toLocaleString('en-US', { ...defaultOptions, ...options });
}

/**
 * Parse a UTC timestamp string to a Date object
 * Ensures the timestamp is correctly interpreted as UTC
 */
export function parseUTCTimestamp(timestamp) {
  if (!timestamp) return null;
  
  let utcTimestamp = timestamp;
  if (typeof timestamp === 'string' && !timestamp.endsWith('Z') && !timestamp.includes('+')) {
    utcTimestamp = timestamp + 'Z';
  }
  
  return new Date(utcTimestamp);
}
